import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }, params) {
      commit("setListLoading", true);
      let list = await api.get("sustainability/business/outcomeAccess", {
        params: params,
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },

    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("sustainability/business/outcomeAccess", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll", {
        business_id: payload.business_id,
      });
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};

      await api
        .put(`sustainability/business/outcomeAccess`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll", {
        business_id: payload.business_id,
      });
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  },
};
